import useIsMobileSize from 'src/hooks/useIsMobileSize';
import { DesktopLayout, WithoutHeader } from 'src/layout';
import { Wrapper, Container } from 'src/widgets/FeedFilter/SidebarShell';
import AIMonitoringBlock from 'src/widgets/FeedFilter/AIMonitoringBlock';
import CollapsibleHintBlock from 'src/components/CollapsibleHintBlock';

import DescribeYourBusiness from 'src/screens/DescribeYourBusiness/Content';

export default function ProfileScreen() {
    const isMobile = useIsMobileSize();

    if (isMobile) {
        return (
            <WithoutHeader showBack>
                <DescribeYourBusiness />
            </WithoutHeader>
        );
    }

    return (
        <DesktopLayout
            rightSidebar={
                <Wrapper
                    elevation={0}
                    square={true}
                >
                    <Container
                        elevation={0}
                        isDisabled={false}
                    >
                        <AIMonitoringBlock />
                        <CollapsibleHintBlock
                            title="Настройка профиля"
                            bullets={[
                                'Заполните информацию о себе и своем бизнесе для лучшей персонализации сервиса.',
                                'Укажите вашу деятельность — это поможет системе точнее находить релевантные лиды.',
                                'Добавьте описание бизнеса — это поможет ИИ лучше понимать ваши потребности.',
                                'Telegram аккаунт используется для уведомлений о новых лидах.',
                            ]}
                            example={[
                                'Например:',
                                'Если вы занимаетесь ремонтом квартир, укажите это в деятельности и опишите, какие услуги предоставляете.',
                            ]}
                        />
                    </Container>
                </Wrapper>
            }
        >
            <DescribeYourBusiness />
        </DesktopLayout>
    );
}
